export default class SumElement extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        SumModule(this);
    }
}


function SumModule(element) {

    let resultHolder = element.querySelector('[x\\\:result]') || null;

    console.log(resultHolder);

    let operands = element.getAttribute('kd-operands');
    let operandInputs;

    if (operands) {
        operandInputs = operands.split('+').map(function(operandSelector) {
            return document.querySelector(operandSelector.trim());
        });
    } else {
        operandInputs = element.querySelectorAll('input');
    }
    
    operandInputs.forEach(function (input) {
        input.addEventListener('keydown', onKeyDown);
        input.addEventListener('change', calculate);
    });

    function onKeyDown(e) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
        }
    }

    function calculate() {
        let sum = 0;
        operandInputs.forEach(input => {
            if (input === resultHolder) {
                return;
            }
            
            let value = parseInt(input.value, 10);
            if (!isNaN(value)) {
                sum += value;
            }
        });

        setResult(sum);
    }

    function setResult(sum) {
        if (resultHolder) {
            if (resultHolder.tagName === 'INPUT') {
                resultHolder.value = sum;
            } else {
                resultHolder.innerText = sum;
            }
        } else {
            element.innerText = sum;
        }
    }

    calculate();

    return this;
}

